import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { FormControlLabel, Radio } from '@mui/material';
import {
    CreateChancel,
    SelectAutocompleteMultiple,
    Input,
    MinLoader,
    NoYet,
    ErrMessage,
    SwitchCustomized,
    DateCalendarForm,
    NumericFormatCustom,
} from 'components';
import { frequencyEnumsConvert, frequencyList } from './constants';
import { Colors, FindLoad, FindSuccessItem, useModal } from 'utils';
import { clientActions, fundingSourceActions, httpRequestsOnSuccessActions } from 'store';
import { authService } from '../../../store/client/client.service';
import { createClientStyle } from './styles';
import moment from 'moment/moment';

const GET_FS_SERVICE = 'GET_FUNDING_SOURCE_SERVICE_BY_ID';
export const AddSingleAuth = ({ item }) => {
    const { fundingSourceServices } = useSelector((state) => ({
        fundingSourceServices: state.fundingSource.fundingSourceServices,
    }));
    const ACTION_TYPE = item?.edit ? 'EDIT_CLIENT_AUTHORIZATION' : 'ADD_CLIENT_AUTHORIZATION';
    const { close } = useModal();
    const client = useSelector((state) => state.client.clientItemInfo);
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const [checkModifiersLoader, setCheckModifiersLoader] = useState(false);
    const classes = createClientStyle();
    const checkIfZero = item?.billedUnits === 0 && item?.completedUnits === 0 && item?.reservedUnits === 0;
    const {
        handleSubmit,
        control,
        watch,
        reset,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        defaultValues: {
            serviceId: null,
            totalUnits: null,
            startDate: null,
            endDate: null,
            chargeRateList: [],
            chargeRateIds: [],
            frequencyLimit: {
                limit: null,
                mode: null,
            },
            apptVisible: true,
        },
    });

    useEffect(() => {
        if (item) {
            dispatch(fundingSourceActions.getFoundingSourceServiceById(item?.payerId, { status: 'ACTIVE' }));
            reset(item);
        }
    }, [item]);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            close();
        }
    }, [success]);

    useEffect(() => {
        const serviceId = watch('serviceId');
        const authorizationId = watch('authorizationId');
        if (serviceId && authorizationId) {
            setCheckModifiersLoader(true);
            authService
                .checkChargeRates({
                    authUniqueId: item?.authorizationUniqueId,
                    // authId: authorizationId,
                    fundingServiceId: serviceId,
                    clientId: client?.id,
                    payerId: item?.payerId,
                })
                .then((res) => {
                    if (item?.chargeRateList) {
                        setValue(`chargeRateList`, [...item?.chargeRateList, ...res?.data]);
                    } else {
                        setValue(`chargeRateList`, res?.data);
                    }
                })
                .catch(() => {})
                .finally(() => {
                    setCheckModifiersLoader(false);
                });
        } else {
            setValue(`chargeRateList`, []);
        }
    }, [watch('serviceId'), watch('authorizationId')]);

    const handleCreate = (data) => {
        const params = {
            authorizedServices: [
                {
                    id: item?.id,
                    payerId: item?.payerId,
                    renderingProvider: item?.renderingProviderId,
                    serviceId: data?.serviceId,
                    authorizationId: item?.authorizationId,
                    authorizationUniqueId: item?.authorizationUniqueId,
                    totalUnits: data?.totalUnits,
                    apptVisible: data?.apptVisible,
                    startDate: data?.startDate,
                    endDate: data?.endDate,
                    chargeRateIds: data?.chargeRateIds,
                    frequencyLimit: {
                        mode: data?.frequencyLimit?.mode,
                        limit:
                            data?.frequencyLimit?.mode === frequencyEnumsConvert.ENTIRE_TERM
                                ? data?.totalUnits
                                : data?.frequencyLimit?.limit,
                    },
                },
            ],
        };
        if (item?.edit) {
            dispatch(clientActions.editClientAuthorization(client?.id, params));
        } else {
            dispatch(clientActions.addClientAuthorization(client?.id, params));
        }
    };

    return (
        <form style={{ width: 440 }} onSubmit={handleSubmit(handleCreate)}>
            <h1 className="modal-header-title">{item?.edit ? 'Edit Authorized Service' : 'Add Authorized Service'}</h1>

            <div className="modal-body-wrapper" style={{ marginBottom: 24 }}>
                <div>
                    <SelectAutocompleteMultiple
                        disabled={item?.edit}
                        loadType={GET_FS_SERVICE}
                        name={`serviceId`}
                        label={'Service Code*'}
                        control={control}
                        options={fundingSourceServices}
                        rules={{ required: 'Service Code is required.' }}
                        renderValue={(option) => `${option?.serviceTypeId?.name} ${option?.cptCode}`}
                        defaultSelected={
                            item?.service && {
                                serviceTypeId: { name: item?.service?.serviceTypeId?.name },
                                cptCode: item?.service?.cptCode,
                            }
                        }
                    />

                    <div className="flex-align-center" style={{ gap: 16 }}>
                        <DateCalendarForm
                            name={'startDate'}
                            label={'Start Date*'}
                            max={watch(`endDate`) ? moment.utc(watch(`endDate`)).format('YYYY-MM-DD') : ''}
                            control={control}
                            rules={{ required: 'Start date is required.' }}
                        />
                        <DateCalendarForm
                            name={'endDate'}
                            label={'End Date*'}
                            min={watch(`startDate`) ? moment.utc(watch(`startDate`)).format('YYYY-MM-DD') : ''}
                            control={control}
                            rules={{ required: 'End date is required.' }}
                        />
                    </div>
                    <div
                        style={{ marginBottom: 18 }}
                        className={`${classes.displayCodeBlock2}`}
                        // className={`${classes.displayCodeBlock2} ${error === 'modifiersPost' || !!authServiceDefaultErrorText ? 'error' : ''}`}
                    >
                        <p className={classes.displayCodeBlockText}>Charge Rates</p>
                        <div className={`${classes.availableModfiers} ${checkModifiersLoader === true ? 'notApplicable' : ''}`}>
                            {checkModifiersLoader ? (
                                <div className={classes.loaderBoxStyle}>
                                    <MinLoader margin={'0'} color={Colors.ThemeBlue} position={'relative'} />
                                </div>
                            ) : (
                                <div className={classes.serviceModifiersContainerStyle}>
                                    <div>
                                        <Controller
                                            name={`chargeRateIds`}
                                            control={control}
                                            rules={{
                                                validate: (value) => value?.length > 0 || 'At least one charge rate must be selected.',
                                            }}
                                            render={({ field, formState: { errors } }) => {
                                                const error = errors?.chargeRateIds?.message;
                                                return (
                                                    <>
                                                        {!!watch(`chargeRateList`)?.length ? (
                                                            watch(`chargeRateList`)?.map((it, itemIndex) => {
                                                                const selectedRates = watch(`chargeRateIds`) || [];
                                                                const isSelected = selectedRates.some((i) => i === it?.id);
                                                                const alreadyUsed = item?.chargeRates?.find((i) => i?.id === it?.id);
                                                                const canEdit = alreadyUsed?.id ? !checkIfZero : false;

                                                                return (
                                                                    <button
                                                                        disabled={canEdit}
                                                                        key={itemIndex}
                                                                        className={`${classes.availableModfier} ${isSelected ? 'checked' : ''}`}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            const updatedRates = isSelected
                                                                                ? selectedRates.filter((i) => i !== it?.id)
                                                                                : [...selectedRates, it?.id];

                                                                            setValue(`chargeRateIds`, updatedRates, {
                                                                                shouldValidate: true,
                                                                            });
                                                                        }}
                                                                    >
                                                                        {it.name}
                                                                    </button>
                                                                );
                                                            })
                                                        ) : (
                                                            <div>
                                                                <NoYet text="No charge rates available" />
                                                            </div>
                                                        )}
                                                        <ErrMessage text={error} styles={{ padding: '6px 0', position: 'relative' }} />
                                                    </>
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="flex-align-center" style={{ gap: 16 }}>
                        <div className="full-width">
                            <NumericFormatCustom
                                name={`totalUnits`}
                                label={'Total Units*'}
                                thousandSeparator={false}
                                fixedDecimalScale={false}
                                control={control}
                                rules={{
                                    required: 'Total Units is required.',
                                }}
                            />
                            {/*<Input*/}
                            {/*    name={`totalUnits`}*/}
                            {/*    label={'Total Units*'}*/}
                            {/*    variant="outlined"*/}
                            {/*    control={control}*/}
                            {/*    rules={{ required: 'Available Units is required.' }}*/}
                            {/*/>*/}
                        </div>
                    </div>
                    <div className="frequency-wrapper">
                        <p className="frequency-title">Set Frequency Limits</p>
                        <Controller
                            name={`frequencyLimit.mode`}
                            control={control}
                            rules={{ required: watch('frequencyLimit.mode') ? null : 'Frequency is required.' }}
                            render={({ field, formState: { errors } }) => {
                                const error = errors?.frequencyLimit?.mode?.message === 'Frequency is required.';
                                return (
                                    <>
                                        {frequencyList.map((i, j) => (
                                            <div className="frequency-box" key={j}>
                                                <FormControlLabel
                                                    label={i?.title}
                                                    control={
                                                        <Radio
                                                            {...field}
                                                            value={i?.value}
                                                            checked={field.value === i?.value}
                                                            style={{
                                                                color: watch('frequencyLimit.mode')
                                                                    ? '#347AF0'
                                                                    : error
                                                                      ? '#FE7070'
                                                                      : watch(`frequencyLimit.mode`) === i?.value
                                                                        ? '#347AF0'
                                                                        : '#D0D5DD',
                                                            }}
                                                            onChange={(e) => {
                                                                field.onChange(e.target.value);
                                                                clearErrors('frequencyLimit');
                                                            }}
                                                        />
                                                    }
                                                />
                                                {watch(`frequencyLimit.mode`) === i?.value &&
                                                    watch(`frequencyLimit.mode`) !== frequencyEnumsConvert?.ENTIRE_TERM && (
                                                        <>
                                                            <p>Enter Unit Limit</p>
                                                            <Input
                                                                name={`frequencyLimit.limit`}
                                                                variant="outlined"
                                                                control={control}
                                                                rules={{ required: 'Limit is required.' }}
                                                            />
                                                        </>
                                                    )}
                                            </div>
                                        ))}
                                    </>
                                );
                            }}
                        />
                    </div>
                    <div className="appt-visible-switcher-wrapper">
                        <SwitchCustomized name={`apptVisible`} control={control} />
                        <p>Appt visible</p>
                    </div>
                </div>
            </div>
            <CreateChancel
                loader={loader?.length}
                type="submit"
                create={item?.edit ? 'Save' : 'Add'}
                chancel={'Cancel'}
                onClose={close}
                buttonWidth="100%"
            />
        </form>
    );
};
